import Feature from 'ol/Feature';
import GeoJSON from 'ol/format/GeoJSON';

import { BoulderModel } from './boulder_model';

class CragModel {
    #feature: Feature;
    #boulders: BoulderModel[];

    constructor(feature: Feature) {
        this.#feature = feature;

        this.#boulders = [];
        const boulders = feature.get('boulders');
        if (boulders) {
            for (const boulder of new GeoJSON().readFeatures(boulders)) {
                this.#boulders.push(new BoulderModel(boulder));
            }
        }
    }

    get feature() {
        return this.#feature;
    }

    get boulders() {
        return this.#boulders;
    }
}

export default CragModel;
